const checkType = (files, accept) => {
  // 解析accept属性，支持多种格式如 '.jpg,.png,.gif' 或 'image/*,.pdf'
  const allowedTypes = accept.split(',').map(type => type.trim().toLowerCase())
  
  for (const file of files) {
    const fileName = file.name.toLowerCase()
    const fileType = file.type.toLowerCase() // MIME type
    
    let isValid = false
    
    for (const allowedType of allowedTypes) {
      if (allowedType.startsWith('.')) {
        // 检查文件扩展名
        if (fileName.endsWith(allowedType)) {
          isValid = true
          break
        }
      } else if (allowedType.endsWith('/*')) {
        // 检查MIME类型通配符，如 'image/*', 'video/*'
        const generalType = allowedType.slice(0, -1) // 移除 '*'
        if (fileType.startsWith(generalType)) {
          isValid = true
          break
        }
      } else {
        // 完全匹配MIME类型
        if (fileType === allowedType) {
          isValid = true
          break
        }
      }
    }
    
    if (!isValid) {
      return false
    }
  }
  
  return true
}

export default checkType